export default __webpack_public_path__ + "static/media/gp.58972804.png";